// extracted by mini-css-extract-plugin
export default {"scroll_container":"styles_scroll_container__Ypdo5"};